module.exports = __webpack_public_path__ + "img/45.b2256208.jpg";